import styled from "styled-components";
import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../../../constants/Styles";

export const Container = styled.div`
  margin-top: 1rem;
`;

export const ShippingRates = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const NoShippingRates = styled.div`
  color: ${COLORS.secondaryLight};
`;

export const ValidationMessages = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 1rem;
  color: ${COLORS.error};
`;

export const AlertText = styled.div`
  color: ${COLORS.primary};
  font-weight: ${FONT_WEIGHT.weight500};
  font-size: ${FONT_SIZE.size12};
  text-align: left;
  margin-top: 1rem;
`;
